<template></template>
<script>
export default {
  name: "EducationManuals",
};
</script>
